const wrapper = "oaewpwkp1i";
const backgroundBlurredImage = "oaeb1jl5kpe";
const svg = "oaes1mxdh89";

export { backgroundBlurredImage, svg, wrapper };
import "./atom.frontpage-graphic.style.linaria.module.css";
//# sourceMappingURL=atom.frontpage-graphic.style.js.map
